import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';
import {LearningChapterModel} from "~~/package/mapper/learning/model/LearningChapterModel";

export class LearningTokenData extends Model {
    constructor(
        public token: string | null = null,
        public hmac: string = "",
        public issuedAt: number = 0,
    ) {
        super();
    }

    public static create(model: Partial<LearningTokenData>): LearningTokenData {
        return createModel<LearningTokenData>(LearningTokenData, {
            ...model
        });
    }
}
